import classNames from "classnames";
import { Dropdown } from "react-bootstrap";
import { ChevronUp, Globe } from "react-bootstrap-icons";

import useLanguageSwitcher from "@/hooks/useLanguageSwitcher";
import changeLanguageEvent from "@/services/analyticsEvents/changeLanguageEvent";

import styles from "./DesktopLanguageSwitcher.module.scss";

interface IDesktopLanguageSwitcherProps {
  className?: string;
}

function DesktopLanguageSwitcher({ className }: IDesktopLanguageSwitcherProps) {
  const { changeLanguage, currentLanguage, languages } = useLanguageSwitcher();

  return (
    <Dropdown drop="up" className={className}>
      <Dropdown.Toggle
        id="dropdown-basic"
        variant="link"
        className={classNames(
          "text-uppercase text-decoration-none d-inline-flex align-items-center gap-3 justify-content-center",
          styles.toggle
        )}
      >
        <Globe />
        <span className="d-inline-flex align-items-center gap-2">
          <span className="fs-8">{currentLanguage}</span>
          <ChevronUp className="chevron" />
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu
        className={classNames("overflow-auto", styles.dropdownMenu)}
      >
        {languages.map((item) => (
          <Dropdown.Item
            key={item.value}
            onClick={() => {
              const language = currentLanguage;
              const newLanguage = item.value;

              changeLanguage(newLanguage);
              changeLanguageEvent({
                language,
                newLanguage,
              });
            }}
            active={currentLanguage === item.value}
          >
            {item.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default DesktopLanguageSwitcher;
